import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Center, Group, Paper, Stack, Text } from '@mantine/core';
import classes from './GamePanel.module.css';
export const GamePlayPanel: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Paper bg="transparent">
      <Stack gap={24}>
        <Text className={gunterzBold.className} fz={{
        base: 'sm',
        lg: 'lg'
      }} c="var(--text-white)">
          {i18n._('How to Play Sweet Bonanza on PrimeRoll')}
        </Text>

        <Group gap={0}>
          <Paper w={{
          base: 50,
          sm: 56,
          lg: 92
        }} h={92} radius={5} bg="var(--input-variant-color)">
            <Center h="100%">
              <Text className={gunterzBold.className} fz={{
              base: 18,
              lg: 32
            }} c="var(--text-prime)">
                {1}
              </Text>
            </Center>
          </Paper>
          <Paper px={20} py={16} classNames={{
          root: classes.paper
        }}>
            <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
              {i18n._('Set Your Bet:')}
            </Text>
            <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
              {i18n._('Use the + or - buttons to adjust your bet amount.')}
            </Text>
          </Paper>
        </Group>

        <Group gap={0}>
          <Paper w={{
          base: 50,
          sm: 56,
          lg: 92
        }} h={92} radius={5} bg="var(--input-variant-color)">
            <Center h="100%">
              <Text className={gunterzBold.className} fz={{
              base: 18,
              lg: 32
            }} c="var(--text-prime)">
                {2}
              </Text>
            </Center>
          </Paper>
          <Paper px={20} py={16} classNames={{
          root: classes.paper
        }}>
            <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
              {i18n._('Spin the Reels:')}
            </Text>
            <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
              {i18n._('Click the spin icon or hit the spacebar to start.')}
            </Text>
          </Paper>
        </Group>

        <Group gap={0}>
          <Paper w={{
          base: 50,
          sm: 56,
          lg: 92
        }} h={92} radius={5} bg="var(--input-variant-color)">
            <Center h="100%">
              <Text className={gunterzBold.className} fz={{
              base: 18,
              lg: 32
            }} c="var(--text-prime)">
                {3}
              </Text>
            </Center>
          </Paper>
          <Paper px={20} py={16} classNames={{
          root: classes.paper
        }}>
            <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
              {i18n._('Win Big:')}
            </Text>
            <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
              {i18n._('Match 8 or more symbols anywhere on the 6x5 grid to win!')}
            </Text>
          </Paper>
        </Group>
      </Stack>
    </Paper>;
};